import React, { Component } from 'react';
import { connect } from 'react-redux';
import { callApiByName } from 'app/api/bridge-proxy';
import { tryRedirectBridgeFailure } from 'app/api/redux-route/route-actions';
import { getComputedBridgeBrand } from '../../api/redux-watson/watson-config-selectors';

export default function withApi(ApiComponent) {
  class ApiCaller extends Component {
    constructor(props) {
      super(props);
      this.boundCallBridgeApi = (...args) => this.callBridgeApi(...args);
    }

    componentDidMount() {
      this.mounted = true;
    }

    componentWillUnmount() {
      this.mounted = false;
    }

    callBridgeApi(methodStr, ...params) {
      return new Promise((resolve, reject) => {
        callApiByName(methodStr, window, params, this.props.bridgeBrand)
          .then(
            data => {
              if (this.mounted) {
                resolve(data);
              }
            },
            data => {
              if (this.mounted) {
                this.props.tryRedirectBridgeFailure(data, methodStr);
                reject(data);
              }
            }
          )
          .catch();
      });
    }

    render() {
      return (
        <ApiComponent {...this.props} callBridgeApi={this.boundCallBridgeApi} />
      );
    }
  }

  return connect(mapStateToProps, { tryRedirectBridgeFailure })(ApiCaller);
}

const mapStateToProps = state => ({
  bridgeBrand: getComputedBridgeBrand(state),
});



// WEBPACK FOOTER //
// ./src/app/ui/bridge/withApi.js